import { isBefore, differenceInDays, parse } from "date-fns";
import { de } from 'date-fns/locale';

/**
 * Checks if the current date is before a given date
 */
export const isBeforeDate = (targetDate: Date): boolean => {
  return isBefore(new Date(), targetDate);
};

/**
 * Checks if two dates are within a given number of days
 */
export const isWithinDays = (
  date1: Date,
  date2: Date,
  days: number
): boolean => {
  const diff = Math.abs(differenceInDays(date1, date2));
  return diff < days;
};

export const parseDE = (
    input: string
) => {
    const date = parse(input, 'dd.MM.yyyy', new Date(), { locale: de })
    return date;
}
